// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"8af9fb53","921":"958a1327"}[chunkId] + ".chunk.js";
};